import { VectorProps } from './types';

const AngleLeft = ({ className, size = 1, color = 'currentColor' }: VectorProps) => {
  return (
    <svg className={className} height={`${size}em`} viewBox="0 0 9.855 18.296">
      <path
        d="M-9261.477-2291.995l-8.795,8.794,8.795,8.795"
        transform="translate(9270.979 2292.348)"
        fill="none"
        stroke={color}
        strokeWidth="1"
      />
    </svg>
  );
};

export default AngleLeft;
